import { createSelector } from 'reselect';
import { PARAMETERS_KEY } from './constants';
import searchSelector from '../searchSelector';
import { Defaults as RefinementDefaults } from '../../constants';

export const IGNORED_PARAMETERS = [
    'procedureId',
    'sortType',
];

export const getSearchParameters = createSelector(
    searchSelector,
    search => search[PARAMETERS_KEY]
);

export const getInsuranceCarrierId = createSelector(
    getSearchParameters,
    params => params.carrierId,
);

export const getInsurancePlanId = createSelector(
    getSearchParameters,
    params => params.planId,
);

export const getNumberOfAppliedRefinements = createSelector(
    getSearchParameters,
    parameters => Object.keys(RefinementDefaults).reduce((count, key) => {
        if (key in parameters
            && !IGNORED_PARAMETERS.includes(key)
            && parameters[key] !== RefinementDefaults[key]
        ) {
            count += 1;
        }

        return count;
    }, 0)
);

export const getNumberOfAppliedAvailabilityRefinements = createSelector(
    getSearchParameters,
    parameters => {
        return parameters.dayFilter !== RefinementDefaults.dayFilter ? 1 : 0;
    }
);

export const getNumberOfAppliedHoursRefinements = createSelector(
    getSearchParameters,
    parameters => {
        let count = 0;

        if (parameters.showTimesAfter5) {
            count += 1;
        }

        if (parameters.showTimesBefore10) {
            count += 1;
        }

        return count;
    }
);

export const getNumberOfAppliedGenderRefinements = createSelector(
    getSearchParameters,
    parameters => {
        return parameters.genderFilter !== RefinementDefaults.genderFilter ? 1 : 0;
    }
);

export const getNumberOfAppliedLanguageRefinements = createSelector(
    getSearchParameters,
    parameters => {
        return parameters.languageId !== RefinementDefaults.languageId ? 1 : 0;
    }
);

export const getNumberOfAppliedMiscRefinements = createSelector(
    getSearchParameters,
    parameters => {
        return parameters.showProvidersWhoSeeChildren !== RefinementDefaults.showProvidersWhoSeeChildren ? 1 : 0;
    }
);
